<template>
  <custom-callout
    :has-toggle="false"
    :border-left-color="statusColor"
    class="vocational-referral-result mb-3"
  >
    <div class="vocational-referral-result__content">
      <div class="vocational-referral-result__status">
        <span
          class="vocational-referral-result__status-dot"
          :style="{ backgroundColor: statusColor }"
        />
        <span class="vocational-referral-result__status-name">
          {{ item.status?.name | empty }}
        </span>
      </div>

      <div class="vocational-referral-result__field">
        <span class="vocational-referral-result__label">
          Número de Referido:
        </span>
        <span class="vocational-referral-result__value">
          {{ item.number | empty }}
        </span>
      </div>

      <div class="vocational-referral-result__field">
        <span class="vocational-referral-result__label">
          Nombre del Estudiante:
        </span>
        <span class="vocational-referral-result__value">
          {{ item.student?.name | empty }}
        </span>
      </div>

      <div class="vocational-referral-result__field">
        <span class="vocational-referral-result__label">
          Fecha de Creación:
        </span>
        <span class="vocational-referral-result__value">
          {{ item.date | formatDate }}
        </span>
      </div>

      <div class="vocational-referral-result__field">
        <span class="vocational-referral-result__label">
          Fecha de Envío:
        </span>
        <span class="vocational-referral-result__value">
          {{ item.sentDate | formatDate | empty }}
        </span>
      </div>

      <div class="vocational-referral-result__actions dropdown">
        <button
          class="btn btn-outline-success dropdown-toggle"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Acciones
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            type="button"
            class="dropdown-item cursor-pointer"
            @click="$emit('enter', item.id)"
          >
            <i class="fas fa-file-import fa-fw text-green mr-2" />
            <span>Ver</span>
          </button>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';

export default {
  name: 'VocationalRehabilitationReferralResultRow',
  components: {
    CustomCallout,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusColor() {
      return this.item.status?.color || '#B7C7C1';
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .vocational-referral-result {
  background: #f7f8f8;
  border-radius: 4px;

  > .row,
  > .row > .col,
  .col.p-2,
  .col-12 {
    margin: 0 !important;
    padding: 0 !important;
  }
}

.vocational-referral-result__content {
  align-items: center;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1.1fr 1.2fr 1.5fr 1.1fr 1fr auto;
  min-height: 4.5rem;
  padding: 1.15rem 1.25rem 1.15rem 2.2rem;
}

.vocational-referral-result__status {
  align-items: center;
  border-right: 1px solid #e2e5e4;
  display: flex;
  min-height: 2rem;
  padding-right: 1rem;
}

.vocational-referral-result__status-dot {
  border-radius: 50%;
  display: inline-flex;
  height: 0.5rem;
  margin-right: 0.6rem;
  width: 0.5rem;
}

.vocational-referral-result__status-name,
.vocational-referral-result__value {
  color: #11291b;
  font-size: 0.875rem;
  font-weight: 600;
}

.vocational-referral-result__field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.vocational-referral-result__label {
  color: #7b8582;
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}

.vocational-referral-result__value {
  overflow-wrap: anywhere;
}

.vocational-referral-result__actions {
  justify-self: end;
}

.vocational-referral-result__actions .btn {
  min-width: 6.75rem;
}

@media (max-width: 991.98px) {
  .vocational-referral-result__content {
    grid-template-columns: 1fr 1fr;
  }

  .vocational-referral-result__status {
    border-right: 0;
    grid-column: 1 / -1;
  }

  .vocational-referral-result__actions {
    justify-self: start;
  }
}

@media (max-width: 575.98px) {
  .vocational-referral-result__content {
    grid-template-columns: 1fr;
    padding-left: 1.25rem;
  }
}
</style>
